import Card from "@mui/material/Card";
import { Grid, CircularProgress, Backdrop } from "@mui/material";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { useForm } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
import configurations from "config";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import { Radio, RadioGroup, FormControlLabel } from "@mui/material";
import { handleErrors } from "common.js";

function WithdrawalConfiguration() {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const baseUrl = configurations.baseUrl;
  const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
  const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;
  const [response, setResponseData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [paymentMode, setPaymentMode] = useState(1);

  const { register, handleSubmit, watch, formState: { errors }, setValue, setError } = useForm({});

  const handlePaymentModeChange = (e) => {
    const value = e.target.value;
    setPaymentMode(value);
    setValue('paymentMode', value);
  };

  const fetchData = async () => {
    setIsLoading(true)
    await axios.get(baseUrl + '/vendor/editWithdrawalConfiguration/', {
      headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey },
    }).then((response) => {
      setIsLoading(false)
      const requestStatus = response.status;
      if (requestStatus == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          const responseData = response.data.data;
          setResponseData(responseData)
          Object.entries(responseData).forEach(([key, value]) => {
            setValue(key, value);
            if (key === 'paymentMode' && key != null) {
              setPaymentMode(value);
            }
          });
        }
        else {
          toast.error(t(message));
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch(error => {
      setIsLoading(false)
      handleErrors(error, t, navigate);
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSubmit = async (data) => {
    setIsLoading(true);
    axios.post(baseUrl + '/vendor/updateWithdrawalConfiguration', data, {
      headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey },
    }).then((response) => {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          toast.success(t(message))
        }
        else {
          if (message != '')
            toast.error(t(message))
          if (response && response.data && response.data.errors) {
            const errorData = response.data.errors;
            errorData.forEach((error) => {
              setError(error.field, {
                type: 'server',
                message: t(error.errors[0])
              });
            });
          }
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch(error => {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  }

  const Bank = () => {
    return (
      <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
        <MDBox px={3}>
          <Grid container spacing={2} alignItems="flex-start" >
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography variant="body1" className="labelStyle">
                {t('payeeName')}
                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
              </MDTypography>
            </Grid>
            <Grid item xs={12} sm={8} md={8}>
              <MDInput
                type="text"
                name="bankPayeeName"
                InputProps={{
                  classes: { root: "inputBoxStyle" },
                }}
                {...register("bankPayeeName", {
                  required: {
                    value: true,
                    message: t('payeeNameRequired')
                  }
                })}
                onChange={((e) => { e.stopPropagation() })}
                fullWidth />
              {errors.bankPayeeName && (
                <span className="errorMsg floatRight">{errors.bankPayeeName.message}</span>
              )}
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography variant="body1" className="labelStyle">
                {t('accountNumber')}
                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
              </MDTypography>
            </Grid>
            <Grid item xs={12} sm={8} md={8}>
              <MDInput
                type="text"
                name="bankAccountNumber"
                InputProps={{
                  classes: { root: "inputBoxStyle" },
                }}
                {...register("bankAccountNumber", {
                  required: {
                    value: true,
                    message: t('bankAccountNumberRequired')
                  },
                  pattern: {
                    value: /^[0-9]{9,18}$/,
                    message: t('bankAccountNumberInvalid')
                  }
                })}
                onChange={((e) => { e.stopPropagation() })}
                fullWidth />
              {errors.bankAccountNumber && (
                <span className="errorMsg floatRight">{errors.bankAccountNumber.message}</span>
              )}
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography variant="body1" className="labelStyle"> {t('bankName')}
                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
              </MDTypography>
            </Grid>
            <Grid item xs={12} sm={8} md={8}>
              <MDInput
                type="text"
                name="bankName"
                InputProps={{
                  classes: { root: "inputBoxStyle" },
                }}
                {...register("bankName", {
                  required: {
                    value: true,
                    message: t('bankNameRequired')
                  }
                })}
                onChange={((e) => { e.stopPropagation() })}
                fullWidth />
              {errors.bankName && (
                <span className="errorMsg floatRight">{errors.bankName.message}</span>
              )}
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography variant="body1" className="labelStyle">{t('branch')}
                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
              </MDTypography>
            </Grid>
            <Grid item xs={12} sm={8} md={8}>
              <MDInput
                type="text"
                name="bankBranch"
                InputProps={{
                  classes: { root: "inputBoxStyle" },
                }}
                {...register("bankBranch", {
                  required: {
                    value: true,
                    message: t('bankBranchRequired')
                  }
                })}
                onChange={((e) => { e.stopPropagation() })}
                fullWidth />
              {errors.bankBranch && (
                <span className="errorMsg floatRight">{errors.bankBranch.message}</span>
              )}
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <MDTypography variant="body1" className="labelStyle">{t('ifsc')}
                <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
              </MDTypography>
            </Grid>
            <Grid item xs={12} sm={8} md={8}>
              <MDInput
                type="text"
                name="bankIFSC"
                InputProps={{
                  classes: { root: "inputBoxStyle" },
                }}
                {...register("bankIFSC", {
                  required: {
                    value: true,
                    message: t('bankIFSCRequired')
                  },
                  pattern: {
                    value: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                    message: t('invalidBankIFSC')
                  }
                })}
                onChange={((e) => { e.stopPropagation() })}
                fullWidth />
              {errors.bankIFSC && (
                <span className="errorMsg floatRight">{errors.bankIFSC.message}</span>
              )}
            </Grid>
            <Grid item xs={12} sm={4} md={4}></Grid>
            <Grid item xs={12} sm={8} md={8}>
              <MDButton type="submit" variant="gradient" color="info" disableRipple>
                {t('submit')}
              </MDButton>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    )
  }

  const UPI = () => {
    return (
      <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
        <MDBox px={3}>
          <Grid container spacing={2} alignItems="center" sx={{ justifyContent: "space-evenly" }}>
            <Grid item xs={4}>
              <MDBox mb={1}>
                <MDTypography variant="body1" align="left" className="labelStyle">
                  {t('upiId')}
                  <MDTypography component="span" variant="body2" fontWeight="bold" color="error">*</MDTypography>
                </MDTypography>
              </MDBox>
            </Grid>
            <Grid item xs={8}>
              <MDBox mb={1}>
                <MDInput
                  type="text"
                  name="upiId"
                  InputProps={{
                    classes: { root: "inputBoxStyle" },
                  }}
                  {...register("upiId", {
                    required: {
                      value: true,
                      message: t('upiIdRequired')
                    },
                    pattern: {
                      value: /[a-zA-Z0-9_-]{3,}@[a-zA-Z]{3,}/,
                      message: t('invalidUPIId')
                    }
                  })}
                  onChange={((e) => { e.stopPropagation() })}
                  fullWidth />
                {errors.upiId && (
                  <p className="errorMsg floatRight">{errors.upiId.message}</p>
                )}
              </MDBox>
            </Grid>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
              <Grid item xs={12} sm={4} md={4}></Grid>
              <Grid item xs={12} sm={8} md={8}>
                <MDButton type="submit" variant="gradient" color="info" disableRipple>{t('submit')}</MDButton>
              </Grid>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    )
  }

  return (
    <DashboardLayout>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {response ?
        <>
          <DashboardNavbar pageTitle={t('WithdrawalConfiguration')} />
          <MDBox pt={6} pb={3}>
            <Grid container spacing={6}>
              <Grid item xs={12}>
                <Card>
                  <MDBox pt={3} px={3}>
                    <MDTypography variant="body1" align="center" className="labelStyle">{t('selectPaymentMode')}</MDTypography>
                    <RadioGroup
                      aria-labelledby="selectPaymentMode"
                      value={paymentMode}
                      name="paymentMode"
                      onChange={handlePaymentModeChange}
                      row
                      className="myRadioGroup"
                    >
                      <FormControlLabel className="radioButtonIcon" value="1" control={<Radio />} label={t("bank")} />
                      <FormControlLabel className="radioButtonIcon" value="2" control={<Radio />} label={t("upi")} />
                    </RadioGroup>
                    {errors.paymentMode && (
                      <span className="errorMsg floatRight">{errors.paymentMode.message}</span>
                    )}
                    {paymentMode == "1" ? (
                      <Bank />
                    ) : (
                      <UPI />
                    )}
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
          </MDBox>
        </>
        : null}
    </DashboardLayout>
  );
}

export default WithdrawalConfiguration;
